module.exports = {"141082001":"鼓楼街道","141082002":"北环路街道","141082003":"南环路街道","141082004":"开元街道","141082005":"退沙街道","141082100":"白龙镇","141082101":"辛置镇","141082102":"大张镇","141082103":"李曹镇","141082200":"陶唐峪乡","141082201":"三教乡","141082202":"师庄乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/141082.json
// module id = 335
// module chunks = 0